export default __webpack_public_path__ + "static/media/closet5-after3-480w.85f9f5aa.png";